import { useRef } from "react";
import logoBadge from "../../assets/REMA/logo_badge.svg";
import ScribbleLine from "./SVGComponents/ScribbleLine";
import { useGSAP } from "@gsap/react";
import { gsap } from "gsap";
import FullWidthScribbleLine from "./SVGComponents/FullWidthScribbleLine";

const RemaConferenceTicker = () => {
  const tickerContainerRef = useRef(null);
  const animationRef = useRef(null);

  const TickerContent = ({ index }) => (
    <div className="flex-shrink-0 flex items-center gap-6 sm:gap-10 whitespace-nowrap">
      {/* Scribble */}
      <div className="flex items-center justify-center px-1 sm:px-3">
        <ScribbleLine staggerIndex={index} />
      </div>

      {/* Text 1 */}
      <span className="text-xs sm:text-sm md:text-base font-bold mx-1 sm:mx-3">
        REMA <br /> Conference 2025
      </span>

      {/* Logo */}
      <img
        src={logoBadge}
        alt=""
        className="inline-block  align-middle"
      />

      {/* Text 2 */}
      <span className="text-xs sm:text-sm md:text-base font-bold mx-1 sm:mx-3">
        November <br /> 6, 2025
      </span>
    </div>
  );

  useGSAP(
    () => {
      if (!tickerContainerRef.current) return;

      const tickerWrap =
        tickerContainerRef.current.querySelector(".ticker-wrap");
      const tickerContent = tickerWrap.querySelector(".ticker-content");

      if (tickerContent) {
        // Clone the content for seamless loop
        const clone = tickerContent.cloneNode(true);
        clone.classList.add("ticker-clone");
        tickerWrap.appendChild(clone);

        // Create seamless infinite scroll animation
        const tl = gsap.timeline({ repeat: -1 });

        tl.set([tickerContent, clone], { x: 0 }).to([tickerContent, clone], {
          x: "-100%",
          duration: 60,
          ease: "none",
        });

        animationRef.current = tl;
      }
    },
    { scope: tickerContainerRef }
  );

  const handleMouseEnter = () => {
    if (animationRef.current) {
      animationRef.current.pause();
    }
  };

  const handleMouseLeave = () => {
    if (animationRef.current) {
      animationRef.current.play();
    }
  };

  return (
    <section className="w-full bg-[#CBF07F] relative overflow-hidden">
      <div className="absolute flex items-center justify-center px-1 sm:px-3 w-screen top-1/2 -translate-y-1/2 opacity-10">
        <FullWidthScribbleLine />
      </div>

      <div
        ref={tickerContainerRef}
        className=" font-sora flex  h-[90px] overflow-hidden w-full cursor-pointer relative"
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <div className="flex-1 w-full flex items-center relative overflow-hidden">
          <div className="ticker-wrap flex items-center font-bold text-[#11302D] leading-tight">
            <div className="ticker-content flex items-center">
              {/* Repeat content multiple times for smooth scrolling */}
              {Array(12)
                .fill(null)
                .map((_, i) => (
                  <TickerContent key={i} index={i} />
                ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RemaConferenceTicker;
